module.exports = __webpack_public_path__ + "img/哇哈哈LOGO.dd07078d.png";